export const se = {
    value: 'Värde',
    footer: {
        text: 'Design och utveckling av Trust Anchor Group',
    },
    userNotifications: {
        notifications: 'Meddelanden',
        text: 'Markera alla som lästa',
    },
    roterLogin: {
        buttonBack: 'Tillbaka',
        spinner: 'Laddar användardata...',
        loginQR: 'Inloggning QR'
    },
    notificationsDropdown: {
        notifications: 'Anmälningar',
        text: 'Markera alla som lästa',
        icon: 'Visa mer...',
    },
    sortableList: {
        search: 'Sök',
        buttonTable: 'Tabell',
        buttonGrid: 'Grid',
        loading: 'Laddar...',
        itemsPage: 'rader per sida',
        noResults: 'Inga resultat hittades.',
        apiErrorResult: 'Kunde inte ansluta till API',
        gettingData: 'Hämtar data...',
        exportData: 'Exportera ',
        all: 'Alla rader',
        generatingFile: 'Hämtar fil ...',
        errorGeneratingFile: 'Fel vid hämtning av fil',
        fileDownloaded: 'Hämtar fil ... Klar',
    },
    reportProceeding: {
        calculations: {
            title: 'Beräkningar',
            subtitle: 'Utveckling',
            salary: 'Arvode',
            gross: 'Brutto',
            hours: 'Antal tim * timarvode eller fast belopp',
            mileage: 'Bilersättning',
            taxFree: {
                title: 'Skattefri del:',
                text: '',
            },
            taxable: {
                title: 'Skattepliktig del:',
                text: 'Km kr + Totalt per passagerare km kr - skattefri del',
            },
            incomeTax: {
                title: 'Innehållen skatt:',
                text: 'Beskattningsbar * Innehållen skatt % / 100',
                textGross: 'Brutto * Innehållen skatt % / 100'
            },
            net: {
                title: 'Netto:',
                text: 'Arbetsgivaravgift + beskattningsbar - Innehållen skatt',
            },
            employmentTax: {
                title: 'Arbetsgivaravgift:',
                text: 'Beskattningsbar * Arbetsgivaravgift % / 100',
                textGross: 'Brutto * Arbetsgivaravgift % / 100'
            },
            expenses: 'Utlägg',
            amount: 'Belopp:',
            amountWithout: 'Belopp exkl moms:',
            tax: 'Skatt',
            total: 'Totalt',
            totalText: 'Belopp + Skatt',
            amountTotal: 'Belopp - Skatt'
        }
    },
    ////////////////////////////////////////////////////////////
    payReceive: {
        payReceiveTitle: 'Betala och Ta emot',
        payReceive: 'Betala/Ta emot',
        pay: 'Registrera utbetalning',
        quickPay: 'Registrera betalningsönskemål',
        bankAccount: 'Bankkonto',
        bankgiro: 'Bankgiro',
        plusgiro: 'Plusgiro',
        selectPayment: 'Välj betalsätt och fyll i betalningsuppgifter',
        payment: 'Betalning',
        transfers: 'Överföringar',
        sign: 'Signera för betalning',
        // buttonPay: ' Betala Faktura',
        // buttonManagement: 'Hantera utlägg',
        // buttonTransfer: 'Direktöverföring',
        quickPayment: 'Snabb betalning',
        quickPayments: 'Snabba betalningar',
        quickPaymentSubtitle: 'Fyll i betalningsuppgifterna',
        //temporalAlert:'Denna sida är endast visuell, den har ingen funktionalitet',
        payInvoice: 'Betala faktura',
        paymentType: 'Betalningstyp',
        email: 'E-postmottagare',
        description: 'Meddelande',
        amountQuickPayment: 'Belopp att betala (inkl moms)',
        infoEmail: 'Skriv eller klistra in mottagarnas e-postadresser. Adresserna kan separeras med ny rad, mellanslag, kommatecken eller semikolon.',
        vatAmount: 'Belopp till kassa (ex moms)',
    },
    payDirectTransmission: {
        transfer: 'Direktöverföring',
        paymentRefers: 'Betalning avser*',
        number: 'Clearingnummer*',
        accountNumber: 'Kontonummer*',
        notes: 'Notering*',
        amount: 'Belopp*',
        //save: 'Spara i lista',
        // sign: 'Signera för betalning',
        second: 'Andra fliken',
        managing: 'Hantera faktura',
        selectInvoice: 'Välj en faktura från listan för att hantera betalningar',
    },
    /*payExpenses:{
        notifications: 'Notiser',
        number: 'Antal förfallna',
        unpaid: 'Obetalda utlägg',
        from: 'Sedan',
        paid: 'Betalda utlägg',
        add: 'Lägg till utlägg',
        new: 'Nytt kvitto',
        manage: 'Hantera faktura',
        select: 'Välj en faktura från listan för att hantera betalningar'
    },
    payInvoice:{
        notifications: 'Notiser',
        number: 'Antal förfallna',
        unpaid: 'Obetalda fakturor',
        date: 'Förfallodatum',
        paid: 'Betalda fakturor',
        add: 'Lägg till faktura',
        new: 'Skapa faktura',
        download: 'Ladda ner underlag',
        sign: 'Signera för betalning',
        manage: 'Hantera faktura',
        select: 'Välj en faktura från listan för att hantera betalningar'
    },*/
    //////////////////////////////////////New/////////////////////////////
    modelLabel: {
        id: 'Id',
        org: 'Organisation',
        orgId: 'Organisations-Id',
        orgName: 'Organisationsnamn',
        orgType: 'Organisationstyp',
        orgDetails: 'Uppgifter om organisationen',
        orgNumber: 'Organisationsnummer',
        orgDestination: 'Destination',
        costPlace: 'Kostnadsställe',
        createdAt: 'Skapad',
        attested: 'Attesterad',
        createdBy: 'Skapad av',
        creatorName: 'Skapad av',
        attestAmount: 'Attestbelopp',
        updatedBy: 'Uppdaterad av',
        updatedAt: 'Uppdaterad kl',
        updatedByName: 'Uppdaterad av (namn)',
        modelId: 'Modell Id',
        user: 'Användare',
        userId: 'Användar-Id',
        userName: 'Personens namn',//Användarnamn
        name: 'Namn',
        parentId: 'Föräldra-Id',
        parentName: 'Tillhör',
        fullName: 'Fullständigt namn ',
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        info: 'Upplysningar',
        country: 'Land ',
        sweden: 'Sverige',
        pnr: 'Personnummer',
        bankSignaturePnr: 'Bankens signatur PNR',
        email: 'E-post',
        phone: 'Telefon',
        employmentTax: 'Arbetsgivaravgift',
        incomeTax: 'Innehållen skatt',
        net: 'Netto',
        date: 'Datum',
        dateReimbursement: 'Aktivitetsdatum',
        dateReceive: 'Kvittodatum',
        status: 'Status',
        amount: 'Belopp',
        amountInvoice: 'Belopp före moms',
        addAmount: 'Lägg till belopp', ///,mirar si esta traduccion se usa en algun sitio, si no borrarla
        type: 'Typ',
        typeId: 'Typ Id',
        types: 'Typer',
        vatAmount: 'Varav moms',
        vatAmountInvoice: 'Moms',
        accountingId:'Utläggstyp',
        accounting:'Utläggstyp',
        fileId: 'Fil Id',
        fileName: 'Filnamn',
        file: 'Lägg till underlag',
        files: 'Filer',
        additionalFileId: 'Ytterligare fil Id',
        additionalFileName: 'Ytterligare filnamn',
        kr: 'kr',
        km: 'km',
        hours: 'Timmar',
        kilometers: 'Total körsträcka (km)',//Körsträcka (km) //kilometres
        total: 'Totalt',
        totalAmount: 'Totalt belopp',
        welcome: 'Välkommen',
        profile: 'Profil',
        logOut: 'Logga ut',
        paid: 'Betald',
        unpaid: 'Obetald',
        yearly: 'Årligen',
        monthly: 'Månadsvis',
        description: 'Beskrivning',
        model: 'Modell',
        balance: 'Balans',
        currency: 'Valuta',
        from: 'Från',
        to: 'Till',
        added: 'Tillagt',
        grossAmount: 'Summa',
        soon: 'Snarast',
        whenToPay: 'Betaldatum',
        reason: "Orsak",
        forYou: 'För dig',
        creditorName: 'Mottagare',
        forYourOrganization: 'För din organisation',
        userSalary: 'Ersättning',
        initialized: 'Skickad',
        aborted: 'Avbruten',
        message: 'Meddelande',
        recipient: 'Mottagare',
        paymentMethod: "Betalningsmetod",
        transactionDate: "Transaktionsdatum",
        approvedDeniedByName: "Hanterad av",
        approvedDeniedAt: "Hanterad",
        generated: "Genererad",
        salarySheet: "Lönespecifikation",
        active: "Aktiv",
        deleted: "Raderad",
        taxAuthority: "Rapporter till Skatteverket",
        taxAuthorityInfo: 'Sammanställning',
        lastRunAt: 'Senaste körningen',
        paymentType: 'Betalningstyp',
        credited: 'Krediterad',
        revoked: 'Återkallad',
        attestQueue: 'För godkännande',
        TheSwedishTaxAgency: 'Skatteverket',
        comment: 'Kommentar',
        download: 'Ladda ner',
        downloading: 'Ladda ner...',
        transaction: 'Öppna betalningstransaktioner',
        bookedDate: 'Bokningsdatum',
        balanceAfterTransaction: 'Balans efter transaktion',
        openPaymentAccountId: 'Öppna betalningskontots ID',
        openPaymentTransactionId: 'Öppna betalningstransaktionens ID',
        openPaymentStatus: 'Öppna betalningsstatus',
        transactionListId: 'Transaktionslistans ID',
        updateTransactions: 'Uppdatera transaktioner',
        consent: 'Samtycke',
        consentCode: 'Samtyckeskod',
        invoiceNumber: 'Fakturanummer',
        paidOut: 'Utbetald',
        sentAt: 'Skickas kl',
        daily: 'Dagligen (Test)',
        collect: 'Samla in',
        reports: 'Rapporter',
        totalDistance: 'Sammanlagd sträcka (km)',
        refresh: 'Uppdatera',
        refreshExpired: 'QR-kodsessionen har löpt ut.',
        provider: 'Betalsätt',
        method: 'Nummer',
        canceled: 'Avbruten',
        fromDateReimbursement: 'Från datum',
        toDateReimbursement: 'Till datum',
        multipleDayEvent: 'Flerdagarsaktivitet',
        KST: 'KST',
        header: 'Rubrik',
        startDate: 'Typ startdatum',
        orgTaxAuthority: 'Organisation',
        reportGenerated: 'Rapport genererad',
        antalPersoner: 'Antal',
        missingAccount: 'OBS: Personen saknar registrerat mottagarkonto',
        lastLogin: 'Senaste inloggning',
        product: 'Produkt',
        hello: 'Hej',
        activityCalendar: 'Kalender',
        activityCalendarTitle: 'Aktivitetskalender',
        activityCalendarDetails: 'Aktivitetskalender Detaljer',
        activityRegistrationRequirement: 'Registreringskrav',
        activityId: 'Id',
        activityName: 'Namn',
        activityDetails: 'Detaljer',
        activityInfo: 'Information',
        activityDates: 'Datum',
        activityfromDate: 'Från',
        activitytoDate: 'Till',
        activityLocation: 'Plats',
        activityType: 'Typ',
        activityOrganizer: 'Arrangör',
        activityPriceMember: 'Pris för medlem',
        activityPriceNonMember: 'Pris för icke medlem',
        activityPrices: 'Priser',
        activityOrganizerRegion: 'Arrangörsregion',
        activityMinimumNumberOfParticipants: 'Minsta antal deltagare',
        activityMaximumNumberOfParticipants: 'Högsta antal deltagare',
        activityTargetGroup: 'Målgrupp',
        title: 'Titel',
        position: 'Position',
        content: 'Innehåll',
        userInfo: 'Användarinformation',
        adminUserInfo: 'Admin användarinformation',
        dropHere: 'Släpp här',
        help: "Hjälp"
    },
    adminLabel: {
        admin: 'Administration',
        organizations: 'Systemets organisationer',
        details: 'Organisationens uppgifter',
        users: 'Systemets användare',
        systemRoles: 'Systemroller',
        orgUser: 'Organisationens användare',
        orgUsers: 'Organisationens användare',
        orgRoles: 'Systemets roller',
        digitalAccount: 'Digitala kassor i systemet',
        systemAdmin: 'Systemadministratör',
        system: 'Systemet',
        allAccount: 'Alla kassor',
        assignRoles: 'Tilldela roller',
        assignOrg: "Tilldela organisation",
        userLoggedOnLastTime: 'Senaste inloggning',
        assignCostPlaces: 'Primära kostnadsställen',
        personalInfo: 'Om',
        roles: 'Roller och behörigheter',
    },
    button: {
        back: 'Tillbaka',
        cancel: 'Avbryt',
        delete: 'Radera',
        send: 'Skicka',
        sendToAttest: 'Skicka till attest',
        sendAndCreateCopy: 'Skicka och påbörja en kopia',
        save: 'Spara',
        loading: 'Laddar...',
        edit: "Redigera",
        info: 'Info',
        accept: 'OK',
        continue: 'Fortsätt',
        moreInfo: 'Mer information',
        hideInfo: 'Dölj information',
        create: 'Skapa',
        assign: 'Tilldela',
        active: 'Aktivera',
        taxAuthority: "AGI-rapporter",
        renew: 'Förnya',
        authorize: 'Godkänn',
        home: "Hem",
        close: "Stäng fönstret",
        saveReimbursement: 'Spara som utkast',
        terminate: 'Avsluta',
        terminateHonorarium: 'Avsluta årsarvode',
        update: 'Uppdatera',
        reactivate: 'Återaktivera',
        moveUp: 'Flytta upp',
        moveDown: 'Flytta ner',
        refill: 'Fyll på LEAB',
        confirm: 'Bekräfta',
        processing: 'Bearbetar...',
        addVat: 'Lägg till',
        loginRoten: 'Logga in via lrf.se',
        readMore: 'läs mer',
        readLess: 'läs mindre',
        change: 'Byt',
        viewFile: 'Visa underlag',
        downloadFile: 'Ladda ner fil',
    },

    validationMessage: {
        sendError: 'Ett fel har uppstått, försök igen senare eller kontakta digitalakassan@lrf.se',
        sendSuccessfully: 'Ersättningsbegäran har lämnats in!',
        fileDeleted: 'Filen har raderats',
        fileFormatIncorrect: 'Filformatet är felaktigt',
        fileFormatCorrect: 'Filformatet är korrekt',
        sendForm: 'Dina uppgifter skickas nu in, vänligen vänta...',
        modalVar: 'Är du säker på att du vill radera',
        modalImage: 'Är du säker på att du vill radera den här bilden?',
        modalItem: 'Är du säker på att du vill ta bort detta objekt?',
        modalAmount: 'Är du säker på att du vill radera detta belopp?',
        fieldRequired: 'Fält krävs',
        validOption: 'Vänligen välj ett giltigt alternativ',
        greater0: 'Värdet måste vara större än 0',
        digits4: 'Numret måste vara 4 siffror',
        digits7: 'Numret måste vara 7 siffror',
        digits2: 'Numret måste vara 2 siffror',
        max12: 'Max 12 siffror',
        bankSignaturePnrLength: 'Bankens signatur PNR måste vara exakt 12 siffror',
        bankSignaturePnrUpdate: 'Bankens signatur PNR har uppdaterats',
        bankSignaturePnrRequired: 'Du måste lägga till Bankens signatur PNR innan du kan signera i banken',
        max140: 'Max 140 tecken',
        max40: 'Max 40 tecken',
        between05and24: 'Värdet måste vara ett heltal mellan 0 och 24',
        minDigit4: 'Numret måste vara minst fyra siffror',
        vatLessAmount: 'Momsbeloppet är för stort',
        fileDeletedImportant: 'Obs! Om du tar bort bilden raderas den permanent, även om du sedan klickar på Avbryt',
        wrong: 'Något gick fel',
        changeNotSave: ' Du har osparade ändringar. Vill du verkligen gå vidare?',
        reimbursementSuccessfully: 'Ersättningsbegäran har skapats',
        reimbursementSavedSuccessfully: 'Ersättningsbegäran har sparats',
        internalTransactionSuccessfully: 'Intern transaktion har skapats',
        honorariumSuccessfully: 'Arvode har skapats',
        honorariumUpdate: 'Arvodet har uppdaterats',
        bankAccountSave: 'Bankkontot har sparats',
        bankAccountUpdate: 'Bankkonto har uppdaterats',
        attestApproved: 'Attest genomförd',
        attestDenied: "Transaktionen har nekats",
        paymentDenied: 'Transaktionen har nekats',
        roleSuccessfully: 'Rollen har skapats framgångsrikt',
        permissionUpdate: 'Behörigheterna har uppdaterats',
        typeSuccessfully: 'Typ har skapats framgångsrikt',
        notAccount: 'Personen har inte registrerat ett bankkonto',
        insufficientBalance: 'Organisationens konto har inte tillräckliga medel',
        modalAttest: 'Vill du verkligen attestera denna post?',
        modalAttestDeny: 'Vill du verkligen neka denna post?',
        modalAttestDenyHeader: 'Neka post',
        modalPaymentDeny: 'Vill du verkligen neka denna betalningen?',
        modalPaymentDenyHeader: 'Neka betalningen',
        canNotBeEmpty: "Fält får inte vara tomt",
        paySuccessfully: 'Betalningen har skapats',
        selectPayment: 'Du måste välja en betalning',
        sendReimbursement: 'Vill du verkligen skicka in denna ersättningsbegäran?',
        saveReimbursement: 'Vill du verkligen spara denna ersättningsbegäran?',
        sendReimbursementNotSaved: "Du har ifyllda uppgifter som inte lagts till och dessa kommer inte registreras. Vill du ändå gå vidare?",
        sendReimbursementNotSavedSave: "Du har ifyllda uppgifter som inte lagts till och dessa kommer inte sparas. Vill du ändå gå vidare?",
        organizationNotMoney: 'Organisationen har inte tillräckligt med pengar',
        sameOrg: 'Organisationerna kan inte vara samma',
        payAborted: 'Betalningen har avbrutits',
        needAccount: 'Du måste ha ett konto för att skicka en begäran',
        goAddAccount: 'Gå till Lägg till konto',
        invalidEmail: 'E-postmeddelandet måste innehålla minst ett @ och en giltig domän (t.ex. example@domain.com)',
        deleteUser: 'Vill du verkligen radera användaren?',
        activeUser: 'Vill du verkligen aktivera användaren?',
        client: 'Slienten har skapats framgångsrikt',
        invoiceSave: 'Fakturan har sparats',
        invoiceSend: 'Fakturan har skickats',
        invoiceSendToAttest: 'Fakturan har skickats för attest',
        needSave: 'Fakturan måste sparas',
        QRCode: 'QR-koden har skapats framgångsrikt',
        clientPermission: 'Du behöver klienttillstånd för att visa detta fält',
        loadingPayment: 'Ladda betalningsmetod',
        dontLetter: 'Endast siffror tillåtna',
        onlyNumbers: 'Felaktigt talformat, använd heltal eller tal med upp till två decimaler',
        creditInvoice: 'Kreditfaktura skapades framgångsrikt',
        sendCreditInvoice: 'Vill du verkligen skapa en fakturakredit?',
        changeStatus: 'Är du säker på att du vill ändra statusen till betalad?',
        consentExpired: 'Samtycket har gått ut',
        consentNotFound: 'Samtycket hittades inte',
        accountIdNotValid: 'Kontot är inte giltigt',
        serviceUnavailableTryAgain: 'Tjänsten är inte tillgänglig, försök igen senare.',
        renewConsentSuccessfully: "Samtycke har förnyats framgångsrikt",
        consentAuthorizationPage: "Sidan för auktorisering av samtycke kommer att öppnas snart",
        activeConsentSuccessfully: "Samtycke har aktiverats framgångsrikt",
        updateTransactionsSuccessfully: "Transaktioner har uppdaterats framgångsrikt",
        consentRejected: "Samtycket har avvisats",
        sendingReimbursement: "Skickar ersättningsbegäran, vänta...",
        savingReimbursement: "Sparar ersättningsbegäran, vänta...",
        sendingPay: "Skickar betalningen, vänta...",
        savingClient: "Sparar mottagare, vänta...",
        sendingInvoice: "Skickar fakturan, vänta...",
        savingInvoice: "Sparar fakturan, vänta...",
        sendingQr: "Skickar QR-koden, vänta...",
        sendingInternalTransaction: "Skickar intern transaktion, vänta...",
        sendingHonorarium: "Skickar arvodet, vänta...",
        loadingSieData: "Laddar SIE-data, vänta...",
        assigningRoles: "Tilldelar roller, vänta...",
        assigningOrgs: "Tilldelar organisationer, vänta...",
        sendingConsent: "Skickar samtycke, vänta...",
        deleteFixed: "Är du säker på att du vill ta bort arvodet?",
        deleteMileage: "Är du säker på att du vill ta bort milersättningen?",
        deleteExpense: "Är du säker på att du vill ta bort utlägget?",
        consentIsValidated: "Samtycket är validerat",
        consentIsValidating: "Validerar samtycke, vänta...",
        selectAmountType: "Det är nödvändigt att välja en beloppstyp",
        dateMustBeLessThanToDate: "Datumet måste vara mindre än eller lika med till datumet",
        totalHourMustBeMoreThan0: "Totalt antal timmar måste vara mer än 0",
        amountMustBeMoreThan0: "Belopp måste vara mer än 0",
        totalAmountMustBeMoreThan0: "Totalt belopp måste vara mer än 0",
        assigningCostPlaces: "Tilldelar kostnadsställen, vänta...",
        sendDenyForm: "En kopia på denna ersättningsbegäran skapas ...",
        opError: "Ett serverfel uppstod, Försök igen om några sekunder.",
        honorariumTerminated: "Arvodet har avbrutits framgångsrikt",
        maxSizeFile: "Filen är för stor. Maxstorleken är 5MB.",
        costBearerUpdate: "Aktivitetsområde har uppdaterats framgångsrikt",
        costbearerSuccessfully: "Aktivitetsområde har skapats framgångsrikt",
        modalReactivate: 'Är du säker på att du vill återaktivera det?',
        modalUpdate: 'Är du säker på att du vill uppdatera det?',
        costBearerReactivated: "Aktivitetsområde har återaktiverats framgångsrikt",
        loading: "Laddar, vänta...",
        assigningOrganizations: "Tilldelar organisationer, vänta...",
        creatingCostBearer: "Skapar aktivitetsområde, vänta...",
        modalDelete: 'Är du säker på att du vill radera det? Det kommer att tas bort permanent.',
        kbarExists: 'Ett aktivitetsområde med samma KBAR finns redan',
        nameExists: 'Ett aktivitetsområde med samma Namn finns redan',
        valueNumeric: 'Värdet måste vara numeriskt',
        max6digits: 'Värdet måste ha högst 6 siffror',
        max999999: 'Värdet måste vara mindre än eller lika med 999999',
        accountingSuccessfully: 'Utläggstypen har skapats framgångsrikt',
        accountingUpdated: 'Utläggstypen har uppdaterats framgångsrikt',
        accountExists: 'Ett utlägg med samma kontonummer finns redan',
        nameExists: 'Ett utlägg med samma namn finns redan',
        creatingAccounting: "Skapar utlägg, vänta...",
        orderUpdated: "Ordningen har uppdaterats framgångsrikt",
        updateAccounting: "Uppdaterar utlägg, vänta...",
        accountingUpdate: 'Utläggstypen har uppdaterats framgångsrikt',
        valueRange: 'Kontovärdet måste vara mellan 1000 och 9999',
        leabRefillSuccessfully: "LEAB-påfyllning genomförd",
        leabRefillError: "Fel vid genomförande av LEAB-påfyllning",
        leabNotFound: "LEAB-organisation hittades inte",
        requiredFields: 'Vänligen fyll i alla obligatoriska fält',
        invalidVatValue: 'Vänligen ange ett giltigt momsvärde (0 eller större)',
        saveSuccess: 'Momskonfiguration sparad',
        updateSuccess: 'Momskonfiguration uppdaterad',
        deleteSuccess: 'Momskonfiguration borttagen',
        loadError: 'Fel vid laddning av momskonfigurationer',
        updateError: 'Fel vid uppdatering av momskonfiguration',
        deleteError: 'Fel vid borttagning av momskonfiguration',
        sendError: 'Ett fel uppstod vid bearbetning av din begäran',
        missingVatId: 'Moms-ID saknas',
        updateVatSuccess: 'Konto uppdaterat',
        cannotBeEmpty: 'Detta fält kan inte vara tomt',
        exact4Digits: 'Året måste bestå av exakt 4 siffror',
        sendDraftHonorarium: 'Är du säker på att du vill fortsätta?',
        reimbursementWillBeProcessed: 'Du kommer bli meddelad när statusen på din begäran uppdateras',
    },
    formPlaceholder: {
        selectDate: 'Välj datum',
        selectOption: 'Välj ett alternativ',
        datePicker: 'Från datum - Till datum',
        enterRole: 'Ange roll',
        enterPermissions: 'Ange behörigheter',
        enterType: 'Ange typ',
        enterQuantity: '', //Ange antal
        enterKm: 'Ange total sträcka i km',
        enterAmount: 'Ange belopp',
        enterAmountQuick: 'Ange belopp som betalas',
        enterAmountVatQuick: 'Ange belopp som tillfaller kassan',
        dragAndDrop: 'Släpp en fil här eller klicka för att välja en',
        enterDate: 'Ange datum',
        enterDateReimbursement: 'Ange datum för aktiviteten',
        enterPurpose: 'Ange syfte',
        enterVatAmount: 'Ange momsbelopp',
        enterHours: 'Ange timmar',
        enterOrigin: 'Ange avreseort',
        enterDeparture: 'Ange avreseort',
        enterDestination: 'Ange destination',
        enterPassengers: 'Ange passagerare',
        enterTotalAmount: 'Ange totalt belopp',
        selectUserName: 'Välj användarnamn',
        selectOrg: 'Välj organisation',
        firstPayment: 'Datum för första betalning',
        modelEnterClearingNumber: 'Ange clearingnummer',
        modelEnterAccountNumber: 'Ange kontonummer',
        reason: 'Ange orsak',
        digits: 'siffror',
        enterCreditorName: 'Ange borgenärens namn',
        selectClientName: 'Välj mottagarnamn',
        enterRecipient: 'Ange mottagarreferens',
        enterReference: 'Ange referens',
        enterPrice: 'Ange enhetspris',
        enterClientName: 'Ange mottagarens namn',
        enterOrgNumber: 'Ange organisationsnummer',
        enterAddress: 'Ange adress',
        enterPostalCode: 'Ange postnummer',
        enterCity: 'Ange ort',
        enterEmail: 'Ange e-postadress',
        enterTitle: 'Rubrik som skrivs ut på skylten, ex Fika',
        enterQRName: 'Namn som bara syns här i systemet, Fika vid årsmöte 2024',
        enterDescription: 'Beskrivning som syns på skylten, ex Kaffe och kaka 20 kr',
        enterComment: 'Ange kommentar',
        enterExtraInfo: 'Ange ytterligare information',
        selectOrgSidebar: 'Byt organisation',
    },
    reimbursement: {
        reportProcessing: 'Ersättningsbegäran',
        reportProcessings: 'Ersättningsbegäran',
        newProcessing: 'Skapa ny ersättningsbegäran',
        sendInfo: "Ange åtminstone ett arvode,bilersättning eller tillägg",
        salary: 'Arvode',//Lägg till arvode
        hourly: 'Timbaserat',
        movable: 'Rörligt',
        fixed: 'Engångsbelopp',
        addSalary: 'Lägg till arvode',
        purpose: 'Syfte',
        costBearer: 'Aktivitetsområde',
        costBearerName: 'Aktivitetsområdets namn',
        expense: 'Lägg till utlägg',
        expenseTitle: 'Utlägg',
        addExpense: 'Lägg till kostnad',
        mileageCompensation: 'Bilersättning',
        mileage: 'Bilersättning',
        addMileageCompensation: 'Lägg till bilersättning',
        passengers: 'Passagerare',
        numberPassengers: 'Antal passagerare',
        addCompensation: 'Lägg till',
        addPassengers: 'Lägg till passagerare',
        addMileage: 'Lägg till körsträcka',
        cancelPassenger: 'Ta bort passagerare',
        origin: 'Från',
        destination: 'Till',
        receipt: 'Underlag',
        programInvitation: 'Bifoga program eller kallelse',
        listParticipants: 'Bifoga deltagarlista',
        amount: 'Belopp',
        addReceipts: 'Lägg till underlag',
        newReimbursementId: "Ersättningsbegäran Duplikatreferens",
        deniedMessage: "Denna begäran om ersättning godkändes inte. Klicka på knappen nedan för att göra korrigeringar och skicka in på nytt.",
        deniedMessageCreate: "Tidigare begäran om ersättning godkändes inte",
        sent: 'För godkännande',
        draft: 'Utkast',
        passengersHelpText: 'Lägg samman de sträckor som varje medpassagerare åkt och skriv in',
        numberOfParticipants: 'Antal deltagare',
        program: 'Lista över deltagare',
        participantsAndPrograms: 'Bilagor',
        addParticipants: 'Lägg till bilagor',
        fixedAmountAtLeast: 'Engångsbelopp måste vara minst {{amount}} kr',
        createAs: 'Skapa {{type}} som:',
        selectOrg: 'Organisation och roll',
        attachedFile: 'Bifogad fil',
        expenseRequiresAttachment: 'Utlägg kräver en bifogad fil',
        generalInformation: 'Allmänt',
    },
    honorarium: {
        honorarium: 'Årsarvode',
        honorariumHistory: 'Årsarvode Historik',
        update: 'Uppdatering av arvode',
        create: 'Skapa årsarvode',
        annual: 'Årsarvodesbelopp',
        payment: 'Betalningsintervall',
        first: 'Första betaldatum',
        queued: 'Kommande betalningar',
        queuedPaid: 'Genomförda betalningar',
        newHonorarium: 'Nytt arvode',
        missingAccountHonorarium: 'Mottagaren har inte registrerat bankkontonummer. När detta är gjort kan ärendet registreras',
        honorariumModalDraft: 'Vill du verkligen spara denna Årligt arvode ?',
        honorariumModalSend: 'Vill du verkligen skicka in denna Årligt arvode ?',
        extraInfo: 'Ytterligare information',
        terminated: 'Avbruten',
        missingAccount: 'Mottagarkonto saknas',
    },
    role: {
        userRole: 'Användarroll',
        orgRole: 'Organisationsroll',
        orgRoles: 'Organisationens roll',
        orgType: 'Organisationstyp',
        roles: 'Roller',
        permissions: 'Behörigheter',
        infoAlert: ' Kom ihåg att trycka på enter för att infoga behörigheterna.',
        addRole: 'Lägg till roll',
        addType: 'Lägg till typ',
        role: 'Roll',
        theseAreThePermissions: 'Det här är de möjliga behörigheterna',
        explanation: 'Om du väljer det första ordet har du full behörighet. ("attest" är som "attest.approve" och "attest.view").Om du lägger till "create","update", "approve","deny" behörigheter individuellt, måste du också välja "view"',
        showRoleButton: 'Visa övriga roller',
        hideRoleButton: 'Dölj övriga roller',
    },
    userSetting: {
        bankAccount: 'Bankkonto',
        settings: 'Mottagarkonto',
        modelClearingNumber: 'Clearingnummer',
        modelAccountNumber: 'Kontonummer',
        validateAccountButton: 'Kontrollera med din bank',
        validateAccountTitle: 'Validera kontonummer',
        name: 'Namn',
        product: 'Produkt',
        cashAccountType: 'Kontant Kontotyp',
        usage: 'Användning',
        accountId: 'Konto Id',
        selectBank: 'Välj din bank',
        accounts: 'Konton',
        infoMessage: `Om du vill kan du verifiera ditt konto direkt med din bank för att underlätta framtida processer eller gör det manuellt, men vi rekommenderar att du validerar det med banken.\n \n Steg för att auktorisera och aktivera en samtyckessession och ett bankkonto:\n 1. Klicka på knappen "Uppdatera kontonummer".\n 2. Ett nytt avsnitt visas med en rullgardinsmeny för att "välja din bank".\n 3. Efter att du har valt din bank aktiveras knappen "Gå vidare" som du måste klicka på. En sida öppnas för att verifiera användaren med BankId eller liknande.\n 4. På den här sidan ser du det konto du vill behålla som ditt primära konto.\n 5. Gå sedan tillbaka till den här sidan så ser du din uppdaterade bankinformation.\n 6. Om du nyligen har lagt till nya konton eller vill visa konton från en annan bank som inte visas i den här listan, upprepa stegen ovan.`,
        infoMessageOp: `Det konto du väljer kommer att användas för att göra penninginsättningen. \n  När kontot har valts stängs den här sidan automatiskt, och du kommer att kunna se din uppdaterade information på  Inställningar.`,
        principalAccount: `Bekräfta om du vill att detta ska vara ditt huvudkonto.`,
        deleteIabn: `Bekräfta om du vill ta bort detta IBAN. \n För att lägga till ett IBAN igen måste du lägga till det direkt med banken, som det lades till tidigare.`,
        account: 'Mottagarkonto',
    },
    digitalAccount: {
        label: 'Digital kassa',
        list: 'Kontolista',
        accountRowList: 'Kontohändelser',
        accountRowInfo: 'Kontoradsinfo',
        swedbankFee: 'Avgift Digitala Kassan',
        totalBalance: 'Totalt saldo på digitala konton',
        totalBalanceSearch: 'Totalt saldo på framsökta konton',
        reservedAmount: 'Reserverat belopp:',
        availableAmount: 'Disponibelt belopp:',
        saldo: 'Saldo:',
    },
    attest: {
        attest: 'Attest',
        approve: 'Godkänn',
        labelListPending: 'Organisationens ärenden att hantera',
        labelListPendingPrimary: 'Mina ärenden att hantera',
        labelListHistory: 'Attesthistorik',
        labelInfo: 'Attestinfo',
        attested: 'Attesterad',
        approved: 'Godkänd',
        pending: 'Utbetalning pågår',
        deny: "Neka",
        denied: "Nekad",
        deniedBy: 'Nekad av',
        paymentInformation: 'Betalningsinformation',
        recipientAccount: 'Mottagarens konto',
        paidDateTime: 'Utbetalningsdatum',
        notEnoughFunds: 'Inte tillräckligt med pengar',
        approvedButNotPaidOut: 'Attesterat att utbetala',
        thisProceeding: 'Detta ärende',
        missingFunds: 'Underskott i kassan',
        balanceAccount: 'Nuvarande saldo',
        relatedProceedings: 'Personens övriga ärenden',
        singleRelatedProceeding: 'Inga övriga ärenden',
        activityDate: 'Aktivitetsdatum',
        organisation: 'Organisation',
        purpose: 'Syfte',
        amount: 'Belopp',
        createdAt: 'Skapad',
        recipient: 'Mottagare',
        warningLokalGroup: `OBS. Detta ärende tillhör en lokal grupp och skall normalt attesteras av en företrädare för den lokala gruppen.`,
        warningLokalGroupSubText: `Vill du ändå gå vidare ?`,
        warningTitleLokalGroup: `! Varning !`,
        attestProceeding: 'Ärendet behöver nu attesteras av någon annan företrädare inom den lokala gruppen.',
        addToPayQueue: 'Lägg till i utbetalningskö',
        addedToPayQueue: 'Ärendet har lagts till i utbetalningskö',
        waitingForAttest: 'Väntar på attest',
        toPaySummary: 'Summa att betala ut',
        orgCost: 'Kostnad för organisationen',
        employerFee: 'Varav arbetsgivaravgift',
        toPay: 'Att utbetala',
        submittedAt: 'Inlämnad',
        accountingSection: 'Kontering',
        unitPrice: 'Å-pris',
        employmentTaxShort: 'Arb.giv.avgift',
        expensesCount: '{{count}} utlägg',
        paymentPlan: 'Utbetalningsplan',
        participantsList: 'Deltagarlista',
        programOrInvitation: 'Program/kallelse',
        otherDocuments: 'Övriga underlag',
        caseLog: 'Ärendelogg',
        logEvent: 'Händelse',
        logSubmitted: 'Inlämnat',
        logAttested: 'Attesterat',
        logDenied: 'Nekat',
        logPaid: 'Utbetalt',
        paymentId: 'Utbetalningsid',
        activityArea: 'Aktivitetsområde',
        attachmentOne: '1 bilaga',
        attachmentsCount: '{{count}} bilagor',
        noAttachments: 'Inga bilagor',
        filePreviewUnavailable: 'Förhandsgranskning kan ej visas.',
    },
    dashboard: {
        dashboard: 'Instrumentbräda',
        bodyTitle: 'Digitala kassan är LRFs nya verktyg för förtroendevalda. ',
        bodyText: 'Beroende på din roll har du tillgång till olika tjänster i vänstermenyn. Systemet är nytt och vi tar gärna emot återkoppling för att förbättra användarupplevelsen.',
        imageError: 'Filformat är inte tillåtna. Endast .jpeg, .jpg, .png och .webp är tillåtna.',
        imageSuccess: 'Bilden har ändrats.',
        textSuccess: 'Texten har ändrats.',
    },
    exportSieFile: {
        label: 'Bokföring',
        moddelExportDocument: 'Vill du förhandsgranska filen eller exportera den direkt?',
        modelPreview: 'Förhandsvisning',
        modelErrorMessageExport: 'Det finns ingen information att exportera i detta datumintervall.',
        periodNotFound: 'Det finns inga uppgifter under denna tidsperiod',
    },
    openPayment: {
        creditorName: 'Mottagare',
        creditorAccountIban: 'Mottagarkonto',
        creditorAccountBban: 'Mottagarkonto',
        bankTransfers: 'Utbetalningar',
        pendingBankList: 'Väntande utbetalningar',
        historyBankList: 'Utbetalningshistorik',
        history: 'Historik',
        bulkPayment: 'Signeringskorg',
        sign: 'Signera',
        instructedAmount: 'Belopp',
        activeConsentCode: "Din aktiva samtyckeskod är",
        consentCodeNotFound: "Samtyckeskoden hittades inte",
        infoMessage: `Steg för att auktorisera och aktivera en samtyckessession:\n 1. Klicka på knappen "Förnya" för att skapa/förnya ett samtycke om du inte har ett eller om det har löpt ut (steg första).\n 2. Efter att ha klickat på knappen "Auktorisera" (steg 2) öppnas en sida för att verifiera användaren med BankId eller liknande, och slutligen omdirigeras du till en sida där samtycke kommer att vara aktivt.\n 3. När du har slutfört dessa steg kan du klicka på knappen "Uppdatera transaktioner".`,
        infoBankTransfer: 'Information om banköverföring',
        myItems: 'Mina ärenden',
        otherItems: 'Organisationens ärenden',
    },
    internalTransaction: {
        internalTransaction: 'Överföra mellan kassor',
        create: 'Skapa intern överföring',
        from: 'Från',
        to: 'Till',
        type: 'Typ',
        subtype: 'Undergrupp',
        selectSubtype: 'Välj undergrupp',
        checkSubtype: 'Välj ett subtyp av intern transaktion.',
        checkOrgsGroup: 'Den mottagande organisationen måste vara "Lokal grupp" för denna undergrupp.',
        amountToAdd: 'Belopp',
        newBalance: 'Nytt saldo',
        newBalancePlaceholder: 'Nytt saldo efter överföring.',
        checkOrgsGroup: 'Den mottagande organisationen måste vara "Lokal grupp" för denna undergrupp.',
        refillLeab: "Fyll på LEAB-konto",
        refillLeabDescription: "Denna åtgärd lägger till virtuella medel på LEAB:s huvudkonto.",
        refillLeabTitle: "Fyll på LEAB-medel",
        refillLeabModalDescription: "Denna åtgärd lägger till virtuella medel på LEAB:s huvudkonto.",
        refillLeabNote: "Denna åtgärd genererar ingen SIE-redovisning och är endast tillgänglig för användare med särskilda behörigheter.",
    },
    accessibility: {
        selectLanguage: 'Språkväljare',
        logo: 'Kassans logotyp kan du gå till instrumentpanelen från denna länk',
        goFirst: 'gå till första sidan',
        goLast: 'gå till sista sidan',
        prevPage: 'föregående sida',
        backPage: 'nästa sida',
        userOptions: 'användaralternativ',
        registered: 'registrerad',
    },
    invoice: {
        invoice: 'Skapa faktura',
        invoiceEconomicReport: 'Kundfaktura',
        creditInvoice: 'Kreditfaktura',
        creditInvoiceRef: 'Fakturareferens',
        createInvoice: 'Skapa faktura',
        createCreditInvoice: 'Skapa kreditfaktura',
        clientName: 'Mottagare',
        invoiceList: 'Kundfakturor',
        addClient: 'Lägg till ny mottagare',
        billingAddress: 'Faktureringsadress',
        invoiceRecipient: 'Fakturamottagare',
        expiringDate: 'Förfallodatum',
        date: 'Förfallodatum',
        recipientRef:'Fakturareferens',
        reference:'Referens',
        invoiceRow: 'Fakturarader',
        productName: 'Namn/beskrivning',
        quantity: 'Antal',
        enterQuantity: 'Ange antal',
        unitPrice: 'Enhetspris (exkl moms)',
        vatAmount: 'Momssats',
        addInvoiceRow: 'Lägg till fakturarad',
        draft: 'Spara utkast',
        sendAttest: 'Skicka för attest',
        previewInvoice: 'Förhandsgranska faktura',
        address: 'Adress',
        postalCode: 'Postnummer',
        city: 'Ort',
        totalPriceRow: 'Radbelopp',
        changeStatus: 'Ändra status',
        paid: 'Betalad',
        sentInvoices: 'Skickade fakturor',
        manageVatConfigurations: 'Hantera fakturakonton',
        accountName: 'Kontonamn',
        vatValue: 'Momsvärde (%)',
        addNewVat: 'Lägg till konto',
        existingVatConfigurations: 'Tillgängliga konton',
        noVatConfigurationsFound: 'Inga momsinställningar hittades',
        actions: 'Åtgärder',
        manageVat: 'Hantera konton',
        invoiceAccounts: 'Fakturakonton',
        deleteVatConfirmation: 'Vill du verkligen ta bort kontot',
        enterVatPercentage: 'Ange momsvärde (%)',
        enterAccountName: 'Ange kontonamn',
        datePaid: 'Betaldatum',
        selectPaymentDate: 'Välj betaldatum',
        paymentDate: 'Betaldatum',
        payNow: 'Betala nu',
        schedulePayment: 'Schemalägg betalning',
        emailToSendFaktura: 'E-post dit fakturan kommer skickas',
        viewDenialReason: 'Visa avvisningsorsak',
        denialReason: 'Avvisningsorsak',
        deniedBy: 'Avvisad av',
        sentAt: 'Fakturadatum',
        accounting: 'Kontonummer',
        momsfritt: 'Momsfritt',
        enterAccounting: 'Ange kontonummer',
    },
    QRCode: {
        title: 'Rubrik',
        info: 'Info',
        name: 'Internt namn för insamlingen',
        orgQRLabel: "QR-insamling",
        thereIsComment: 'Kräv att betalare anger ett meddelande',
        generate: 'Generera QR-skylt',
        create: 'QR-kod för insamling',
        totalPaid: 'Insamlat belopp',
        totalPayments: 'Antal betalningar',
        amount: 'Ange eget belopp i stället:',
        choosePaymentMethod: 'Gå vidare till betalsätt',
        label: 'QR-kod för insamling',
        totalCollected: 'Totalt insamlat',
        disable: 'Inaktivera insamling',
        enable: 'Aktivera insamling',
        addCollection: 'Skapa ny insamling',
        listActive: 'Aktiva QR-insamlingar',
        listInactive: 'Avaktiverade QR-insamlingar',
        defaultAmounts: 'Ange ett eller flera valbara belopp. Tryck på enter efter varje belopp för att bekräfta. ',
        defaultAmountsToContribute: 'Välj belopp att betala',
        addCustomAmount: 'Låt betalaren ange valfritt belopp',
        paymentsReceived: 'Inkomna betalningar',
        generalInformation: 'Allmänt',
        collectionAmount: "Belopp för insamlingen",
        appearanceSign: "Skyltens utseende",
        other: "Övrigt",
        otherInfo: "Det går inte att se vem som genomfört en betalning, bara kortnummer eller mobilnummer, så om du t ex vill ta emot en anmälning får du uppmana personerna att skriva sitt namn i meddelanderutan vid betalning.",
        infoLarge: "Lägg till information här om vad du vill ta betalt för och ev prisinformation",
        inactiveQRCode: "För närvarande är denna QR-kod inaktiv. Vänligen kontakta organisationen."
    },
    economicReport: {
        economicReport: 'Ekonomisk rapport',
        economicReportInfo: 'Ekonomisk rapport info',
        checkboxSubtypes: 'Dela upp i subtyper',
        details: 'Detaljer',
        orgEconomicReport: 'Ekonomisk Rapport för',
    },
    infoBox: {
        internalTransaction: 'Här kan du föra över pengar mellan olika organisationer inom Digitala Kassan. En genomförd överföring äger rum omedelbart och syns på båda kontonas kontoutdrag. \nEn intern överföring skapar ingen verklig bokföring, och funktionen kan inte heller användas för att flytta pengar ut ur systemet.',
        reportProceeding: 'Här kan du lämna in ersättningsbegäran för arvode, bilersättning och utlägg du haft. \nEn inlämnad begäran attesteras av personal inom LRF och betalas ut löpande till det konto du angett. \nEn ersättningsbegäran registreras för den organisation du tillhör och blir en utgift där. \nOm du tillhör flera organisationer behöver du säkerställa att du lämnar in begäran för rätt organisation. \nOBS att moms på utlägg kommer inte belasta organisationens konto.',
        salarySheet: 'Här hittar du dina lönespecifikationer med information om den ersättning du fått utbetald. \nLönespecifikationer genereras i början av en månad och innehåller information om utbetalningar som genomförts föregående månad.',
        quickPayment: 'Här kan du skicka ut e-postmeddelande till en eller flera mottagare där du ber om pengar. \nMeddelandet innehåller en länk till Digitala Kassans betalsida, och de pengar som betalas in blir omedelbart tillgängliga på organisationens konto här i kassan. \nDenna funktion kan användas t ex för att enkelt ta in deltagaravgifter innan ett arrangemang ägt rum. \nOBS att beloppet innehåller moms. \nExempel: begär du 100 kr kommer 20 kr avgå i moms, så organisationens kassa kommer öka med 80 kr ',
        qrPayment: 'Här kan du skapa en QR-kod för insamling av pengar, till exempel för entréavgifter, parkering eller annat som görs på plats vid ett arrangemang. \nBesökaren kan skanna koden med sin mobilkamera (inte swish-appen).  \nQR-koden leder då till en betalsida där man sedan kan välja betalsätt (Swish eller kort) och du kan i förväg bestämma vilka belopp som ska vara möjliga att ange.\nOBS att beloppet innehåller moms. \nExempel: begär du 100 kr kommer 20 kr avgå i moms, så organisationens kassa kommer öka med 80 kr',
        attestPrimary: "Här ser du de ärenden som tillhör de primära kostnadsställen som tillhör din användare. Om något inte stämmer, kontakta supporten",
        createInvoice: 'Med den här funktionen kan ni skapa kundfakturor till företag i pdf format till en mejladress. Däremot kan Digitala kassan inte hantera elektroniska fakturor, när det krävs kontaktar ni supporten.\n1. Ni skapar kundfakturan, välj artikel\n   • 3041 Sålda tjänster (utförda tjänster åt företag)\n   • 3919 Deltagarintäkter (studieresor eller kurs)\n   • 3990 Annons-/utställningsplats (logga i inbjudan/program, deltagande arrangör på aktivitet eller monterplats)\n   • 3989 Gåva/bidrag (företag som bidrag till aktivitet där de inte erhåller någon motprestation ex där företagets logga inte finns med)\n2. Kundfakturan går vidare för godkännande hos Digitala Kassans support\n3. Godkänd kundfaktura mejlas ut till den e-postadress ni angett som mottagare\n4. När kundfakturan är betald kommer beloppet före moms att sättas in på er Digitala kassa\nKundfakturan ställs ut med Lantbrukarnas Ekonomi AB som avsändare, förutom för lokala grupper och sociala utskott där kundfakturans avsändare är Lantbrukarnas Riksförbund (ideell förening)',
        attest: "Här ser du de ärenden som tillhör din organisation, men inte något av dina primära kostnadsställen. Om något inte stämmer, kontakta supporten",
        duplicatePayment: 'Denna betalning är identisk med en annan pågående utbetalning så den har tagits bort ur korgen. Fullfölj den första betalningen inklusive kontrasignering innan den andra läggs upp på nytt.',
        duplicatePaymentStatus: 'Denna betalning är identisk med en annan pågående utbetalning så den har tagits bort ur korgen. Fullfölj den första betalningen inklusive kontrasignering innan den andra läggs upp på nytt.',
        economicReport: 'I denna rapport kan du följa upp ekonomisk aktivitet för de organisationer och kostnadsställen du har tillgång till',
        orgEconomicReport: 'I denna rapport kan du följa upp kostnader och intäkter. Genom de olika filtren nedan kan du välja att visa olika tidsintervall, kostnadstyper mm samt också få ut totala summan för dessa.',
    },
    orgCronjob: {
        updateAll: 'Uppdatera alla organisationer',
        updateOne: 'Uppdatera organisation',
        updateSelected: 'Uppdatera organisation',
    },
    costBearer: {
        costBearer: 'Aktivitetsområden',
        newCostBearer: 'Nytt aktivitetsområde',
        updateCostBearer: 'Uppdatera aktivitetsområde',
        deleteCostBearer: 'Radera aktivitetsområde',
        noCostBearersAssigned: 'Inga aktivitetsområden tilldelade',
        noPermissionsAssigned: 'Inga behörigheter tilldelade',
        assignedCostBearers: 'Tilldelade aktivitetsområden',
        permissions: 'Tilldelade behörigheter',
        costBearerByOrgType: 'Aktivitetsområden per organisationstyp',
        addMissingCostBearers: 'Lägg till saknade aktivitetsområden',
        clickToRemove: 'Klicka för att ta bort aktivitetsområde',
        orgTypeButton: 'Organisationstyper',
        name: 'Namn',
        showLabel: 'Visa etikett',
        value: 'KBAR',
        message: 'Förklaring',
        create: 'Skapa aktivitetsområde',
        update: 'Uppdatera aktivitetsområde',
        yes: 'Ja',
        no: 'Nej',
        includedInAGILabel: 'Räknas som styrelsearvode enligt SKV',
        costbearerModalSend: 'Vill du verkligen skapa detta aktivitetsområde?',
        organizations: 'Organisationer',
        selectOrganizations: 'Välj vilka organisationer som kan använda detta aktivitetsområde',
        assignedToCount: 'Tilldelad till {{count}} av {{total}} organisationer',
        addedToOrg: 'Aktivitetsområde tillagt till organisation',
        removedFromOrg: 'Aktivitetsområde borttaget från organisation',
        relatedOrgs: 'Organisationer',
        organizationsUpdated: 'Organisationer uppdaterade',
    },
    accounting: {
        accountingList: 'Utläggstyper',
        createAccounting: 'Skapa utläggstyp',
        selectRequiredDocs: 'Välj obligatoriska underlag',
        value: 'Kontonummer',
        name: 'Namn',
        message: 'Beskrivning',
        requiredDocumentation: 'Nödvändiga underlag',
        create: 'Skapa utläggstyp',
        accountingModalSend: 'Vill du verkligen skapa denna utläggstyp?',
        update: 'Uppdatera utläggstyp',
    },
    sidebar: {
        reimbursement: 'Ersättningsbegäran',
        salarySheet: 'Lönespecifikation',
        digitalAccount: 'Digital kassa',
        payInvoice: 'Betala faktura',
        collect: 'Samla in',
        quickPayments: 'Snabba betalningar',
        QRcode: "QR-insamling",
        invoice:'Kundfaktura',
        orgUsers: 'Organisationens användare',
        orgDetails: 'Uppgifter om organisationen',
        attest: 'Attest',
        allAccount: 'Alla kassor',
        allAttest: 'Alla Attest',
        internalTransaction: 'Överföra mellan kassor',
        bankTransfers: 'Utbetalning',
        sentInvoices: 'Kundfakturor',
        honorarium:'Årsarvoden',
        reports:'Rapporter',
        taxAuthority: "Rapporter till skattemyndigheten",
        taxAuthorityInfo: 'Sammanställning',
        exportSie: 'Bokföring',
        org: 'Organisation',
        user: 'Användare',
        roles: 'Roller',
        OPtransaction: 'Öppna betalningstransaktioner',
        economicReport: 'Ekonomisk rapport',
        costBearer: 'Aktivitetsområden',
        accountingList: 'Utläggstyper',
        apiKey: 'API-nycklar',
        settings: 'Inställningar',
        swedbankReport: 'Swedbank Pay Rapport',
        guide: 'Guider',
        economic: 'Ekonomi',
    },
    swedbankReport: {
        redovisningsnummer: 'Redovisningsnummer',
        redovisningsdatum: 'Redovisningsdatum',
        utbetaltBelopp: 'Utbetalt belopp',
        totalTransactions: 'Totalt antal transaktioner',
        merchantId: 'Merchant ID',
    },
    quickAccess: {
        title: 'Snabbval',
        ersattning: 'Ersättningsärenden',
        samlain: 'Samla in',
        swedbankpay: 'Snabba betalningar',
        qrCode: 'QR-koder',
        invoiceList: 'Kundfaktura',
    },
        menu: {
        menu: 'Meny',
        startsida: 'Startsida',
        guides: 'Guider',
    },
    guide: {
        guide: 'Guider',
        update: 'Uppdatera guide',
        updated: 'Guide uppdaterad',
        deleted: 'Guide borttagen',
        updatedAt: 'Uppdaterad',
        routeId: 'Rutt',
        description: 'Beskrivning',
        descriptionPlaceholder: 'Ange en beskrivning för guiden',
        guides: 'Guider',
        // ── HelpPanel ──
        visible: 'Aktiv',
        hidden: 'Utkast',
        newGuide: 'Ny guide',
        createGuide: 'Skapa guide',
        noGuide: 'Inga guider ännu för denna vy.',
        noTitle: '(ingen titel)',
        confirmDelete: 'Ta bort denna artikel / guide?',
        chapter: 'Kapitel',
        position: 'Position',
        contentPlaceholder: 'Skriv artikelinnehållet här...',
        editGuide: 'Redigera artikel',
        moveOrCopy: 'Flytta eller kopiera',
        move: 'Flytta',
        copy: 'Kopiera',
        rootLevel: 'Rotnivå',
        moveGuide: 'Flytta guide',
        confirmDelete: 'Är du säker på att du vill ta bort denna artikel / guide? Denna åtgärd kan inte ångras.',
        newArticle: 'Ny artikel',
        moveGuide: 'Flytta guide',
        noGuide: 'Inga artiklar ännu för denna vy.',
        noContent: 'Inget innehåll',
        dragToMove: 'Dra för att flytta',
        newSubContainer: 'Ny underbehållare',
        emptyContainer: 'Tom behållare',
        deleted: 'Artikel borttagen',
        containerDeleted: 'Behållare borttagen',
        noGuides: 'Inga artiklar ännu för denna vy.',
        confirmDeleteContainer: 'Är du säker på att du vill ta bort denna behållare? Denna åtgärd kan inte ångras.',
        newContainer: 'Ny behållare',
        markReviewed: 'Markera som granskad',
        lastReviewed: 'Senast granskad',
        neverReviewed: 'Aldrig granskad',
        reviewed: 'Granskad:',
        title: 'Titel',
        publicated: 'Publicerad',
        unsectioned: 'Oavsnittad'
    },
    economic: {
        invalidYearRange: 'Från-år måste vara mindre än eller lika med Till-år',
        overlappingYears: 'Årtalen överlappar med en befintlig inställning ({{from}} - {{to}})',
        title: 'Ekonomiska inställningar',
        arvoden: 'Arvoden',
        timarvode: 'Timarvode',
        milersattningar: 'Milersättningar',
        skattefri: 'Varav skattefri del',
        skattepliktig: 'Sammanlagd milersättning',
        passagerarersattning: 'Passagerarersättning',
        skatter: 'Skatter',
        preliminarSkatt: 'Preliminär skatt',
        arbetsgivaravgifter: 'Arbetsgivaravgifter',
        arbetsgivaravgiftPercent: 'Arbetsgivaravgift',
        belopp: 'Belopp',
        beloppPerMil: 'Belopp / mil',
        sats: 'Värde',
        maxPercent: 'Värdet får inte vara högre än 100 %',
        mileageTotalBelowTaxFree: 'Sammanlagd milersättning får inte vara lägre än den skattefria delen ({{value}} kr)',
        mileageTaxFreeAboveTotal: 'Den skattefria delen får inte vara högre än sammanlagd milersättning ({{value}} kr)',
        avgift: 'Avgift',
        employerContributionTier1: 'Arbetsgivaravgift (1900-1937)',
        employerContributionTier2: 'Arbetsgivaravgift (1938-1958)',
        employerContributionTier3: 'Arbetsgivaravgift (1959-2002)',
        employerContributionTier4: 'Arbetsgivaravgift (2003-2007)',
        employerContributionTier5: 'Arbetsgivaravgift (2008-2026)',
        birthYearFrom: 'Födelseår från',
        birthYearTo: 'Födelseår till',
        arbetsgivaravgift: 'Arbetsgivaravgift (%)',
        defaultSetting: 'Standardvärde (om inget annat matchar)',
        defaultSettingTitle: 'Standardvärde',
        defaultSettingSubtitle: 'om inget annat matchar',
        addYearRow: 'Lägg till åldersintervall',
        updateSuccess: 'Inställningarna har uppdaterats',
        updateError: 'Fel vid uppdatering av inställningar'
    },
    salarySheet: {
        info: "Planerat för denna månad",
        payout: "Utbetalning",
        paymentDetails: "Betalningsdetaljer",
    },
    apiKey: {
        apiKeys: 'API-nycklar',
        apiKey: 'API-nyckel',
        description: 'Nycklar som externa system (t.ex. Umbraco) använder för att skapa snabbetalningar i Kassan.',
        newApiKey: 'Ny API-nyckel',
        name: 'Namn',
        namePlaceholder: 't.ex. Umbraco produktion',
        nameMaxLength: 'Namnet får vara högst 100 tecken',
        prefix: 'Nyckel',
        expiresAt: 'Utgår',
        expiresAtOptional: 'Utgångsdatum (valfritt)',
        lastUsedAt: 'Senast använd',
        createdByName: 'Skapad av',
        never: 'Aldrig',
        neverUsed: 'Aldrig använd',
        statusActive: 'Aktiv',
        statusExpired: 'Utgången',
        statusRevoked: 'Återkallad',
        createIntro: 'Skapa en API-nyckel för ett externt system:',
        createHelp: 'Ge nyckeln ett namn så att ni vet var den används. Nyckeln visas bara en gång efter att den har skapats.',
        creating: 'Skapar API-nyckel...',
        copyNowTitle: 'Kopiera nyckeln nu',
        copyNowText: 'Av säkerhetsskäl visas nyckeln bara en gång. Spara den på ett säkert ställe och lägg in den i det externa systemet. Om den tappas bort måste en ny nyckel skapas.',
        headerUsage: 'Det externa systemet ska skicka nyckeln i headern',
        copy: 'Kopiera',
        copied: 'Kopierad',
        copyError: 'Det gick inte att kopiera nyckeln, markera och kopiera den manuellt',
        done: 'Klar',
        revoke: 'Återkalla',
        revokeConfirm: 'Vill du återkalla API-nyckeln "{{name}}"?',
        revokeWarning: 'Nyckeln slutar fungera direkt och det går inte att ångra. System som använder den kommer att få fel tills de får en ny nyckel.',
        revokedSuccessfully: 'API-nyckeln har återkallats',
        revokedAt: 'Återkallad',
        revokedByName: 'Återkallad av',
    }
};
